import * as RaftingPlugin from './rafting';
import * as CampingPlugin from './camping';

const plugins = {
    'rafting': RaftingPlugin,
    'camping': CampingPlugin,
    'accommodation': CampingPlugin // Map both keys to the same plugin
};

export default {
    get: (type) => plugins[type] || RaftingPlugin // Fallback to Rafting
};
